import { useCallback, useContext } from 'react';
import _get from 'lodash/get';

import { AuthContext } from 'context/AuthContext';
import useEcomPlatform from './useEcomPlatform';
import { RETURNS_MODES } from 'dictionary';

export default function useRetailer() {
  const { storeProperties } = useContext(AuthContext);
  const { checkIfPlatformIs } = useEcomPlatform();

  const getStoreProperty = useCallback(
    (property, defaultValue) => _get(storeProperties, property, defaultValue),
    [storeProperties]
  );

  const ssSellerId = getStoreProperty('ss_seller_id');
  const isSSRStore = getStoreProperty('is_ssr_retailer', false);
  const storeUniqueName = getStoreProperty('store_unique_name');

  const isAdvancedMode = !checkIfPlatformIs('SS_GENERIC_ECOM');

  const prefix = isSSRStore ? 'SSR' : 'RR';
  const brand = isSSRStore ? 'ShipStation Returns' : 'Return Rabbit';
  const merchantId = !!storeUniqueName ? `${prefix}-${storeUniqueName}` : null;
  const returnsMode = isAdvancedMode
    ? RETURNS_MODES.ADVANCED
    : RETURNS_MODES.BASIC;

  return {
    brand,
    merchantId,
    ssSellerId,
    isSSRStore,
    returnsMode,
    isAdvancedMode,
    getStoreProperty
  };
}
